import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { serializer3pi9q3u39g4ku as serializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { printStackTrace18lnx7a39cni as printStackTrace } from '../../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { removePrefix279df90bhrqqg as removePrefix } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _SealedTypeDiscriminator___init__impl__jf77jn(serialName) {
  return serialName;
}
function _SealedTypeDiscriminator___get_serialName__impl__x46m55($this) {
  return $this;
}
function _SealedTypeDiscriminator___init__impl__jf77jn_0(serializer) {
  return _SealedTypeDiscriminator___init__impl__jf77jn(serializer.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$());
}
function SealedTypeDiscriminator__hashCode_impl_3l9vn8($this) {
  return getStringHashCode($this);
}
function matches(_this__u8e3s4, value) {
  var tmp;
  if (!(value == null)) {
    var tmp_0;
    try {
      var tmp_1 = getKClassFromExpression(value);
      // Inline function 'kotlin.collections.listOf' call
      var tmp$ret$0 = emptyList();
      var ser = serializer(tmp_1, tmp$ret$0, false);
      tmp_0 = ser.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() === _SealedTypeDiscriminator___get_serialName__impl__x46m55(_this__u8e3s4);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof SerializationException()) {
        var e = $p;
        println('WARN! SealedTypeDiscriminator could not find a serializer for ' + toString(value) + " to determine if the type matched '" + _SealedTypeDiscriminator___get_serialName__impl__x46m55(_this__u8e3s4) + "'");
        printStackTrace(e);
        tmp_2 = false;
      } else {
        throw $p;
      }
      tmp_0 = tmp_2;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
}
function variantShortName(_this__u8e3s4, discriminator) {
  // Inline function 'kotlin.takeIf' call
  var this_0 = removePrefix(_SealedTypeDiscriminator___get_serialName__impl__x46m55(discriminator), _this__u8e3s4.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() + '.');
  var tmp;
  if (!(this_0 === _SealedTypeDiscriminator___get_serialName__impl__x46m55(discriminator))) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  return tmp;
}
//region block: exports
export {
  matches as matches17hm1adjr5zld,
  variantShortName as variantShortNamey38i8usgp8vx,
  _SealedTypeDiscriminator___init__impl__jf77jn_0 as _SealedTypeDiscriminator___init__impl__jf77jnb2draso4x6g,
  SealedTypeDiscriminator__hashCode_impl_3l9vn8 as SealedTypeDiscriminator__hashCode_impl_3l9vn82rzp7wjugbfem,
  _SealedTypeDiscriminator___get_serialName__impl__x46m55 as _SealedTypeDiscriminator___get_serialName__impl__x46m55cpdzns363t1u,
};
//endregion

//# sourceMappingURL=SealedTypeDiscriminator.mjs.map
